import { Link } from 'react-router-dom';

/**
 * Reusable legal-page layout — dark, restrained, easy to scan on phones.
 * Children render the body markup; this just owns the chrome (header, last-updated, container, back link).
 */
const LegalLayout = ({ title, lastUpdated, children }) => (
  <div className="min-h-screen bg-[#050505] pt-20 sm:pt-28 pb-16 px-4" data-testid="legal-page">
    <div className="container mx-auto max-w-3xl">
      <Link
        to="/"
        className="font-mono text-xs text-zinc-500 tracking-widest hover:text-[#B5FF00] transition-colors inline-block mb-6"
      >
        ← BACK TO UNIGHT
      </Link>
      <h1 className="font-['Josefin_Sans'] text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-3 leading-none">
        {title}
      </h1>
      {lastUpdated && (
        <p className="font-mono text-xs text-[#B5FF00] tracking-widest mb-10 sm:mb-12">
          LAST UPDATED · {lastUpdated.toUpperCase()}
        </p>
      )}
      <div className="space-y-8 text-zinc-300 leading-relaxed">{children}</div>
    </div>
  </div>
);

export default LegalLayout;
